import React, {Component} from 'react';
import formatters from "../../../../../utils/formatters";

export default class TripProviderForm extends Component {

    render() {
        let trip = this.props.trip;
        if(!trip)return <div />;

        let form = (
            <div className={"row"}>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Información Viaje</h4>
                    </div>
                    <div className={"row margin-top-10"}>
                        <div className={"col s6 input-field disabled"}>
                            <label className="active">Proveedor</label>
                            <p className={"field-p truncate"}>{trip.provider.business_name}</p>
                        </div>
                        <div className={"col s6 input-field"}>
                            <label className="active">Producto</label>
                            <p className={"field-p"}>{trip.product.code}</p>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Tipo de viaje</label>
                            <p className={"field-p"}>Viaje {trip.incoterm.name}</p>
                        </div>
                        <div className={"col s6 input-field"}>
                            <label className="active">Destino</label>
                            <p className={"field-p"}>{trip.terminal.name}</p>
                        </div>
                    </div>
                    <div className={"row thin-row"}>
                        <div className={"col s6 input-field "}>
                            <label className="active">Fecha de Carga</label>
                            <p className={"field-p"}>{formatters.dateFormat(trip.load_datetime)}</p>
                        </div>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Cantidad Carga</label>
                            <p className={"field-p"}>{formatters.intFormat(trip.provider_load_volume)}</p>
                        </div>
                    </div>
                </div>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Información Transporte</h4>
                    </div>
                    <div style={{borderLeft: '1px solid #404040', paddingLeft: 20}}>
                        <div className={"row margin-top-10"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Empresa Transportista</label>
                                <p className={"field-p"}>{trip.carrier}</p>
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Nro. Remito</label>
                                <p className={"field-p"}>{trip.provider_trip_receipt}</p>
                            </div>
                        </div>
                        <div className={"row margin-top-10"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Chofer - Nombre y Apellido</label>
                                <p className={"field-p"}>{trip.driver_name}</p>
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Licencia de Conducir</label>
                                <p className={"field-p"}>{trip.driver_doc}</p>
                            </div>
                        </div>
                        <div className={"row thin-row"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Patente Chasis</label>
                                <p className={"field-p"}>{trip.truck_plate}</p>
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Patente Acoplado</label>
                                <p className={"field-p"}>{trip.trailer_plate}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"col s12 input-field input-grey"}>
                    <label className="active">Observaciones</label>
                    <p className={"field-p"}>{trip.provider_observations}</p>
                </div>
            </div>
        );

        if(this.props.boxed){
            return (
                <div className={"trip-section"}>
                    <div className={'trip-section-title'}>Viaje Ingresado</div>
                    {form}
                </div>
            );
        }

        return form;
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Done/TripProviderForm.js